import { useAppSelector } from 'store/hooks';
import { SettingSelectors } from 'store/Settings';
import { UserSelectors } from 'store/User';

export const useHeaderDisplaySettings = (props?: {
  ignoreDeviceSetting?: boolean;
}) => {
  const { ignoreDeviceSetting } = props ?? {};

  const interfaceSettingsFeatureFlag = useAppSelector(
    UserSelectors.selectInterfaceSettings,
  );

  const {
    shouldDisplayCustomerAddress: _shouldDisplayCustomerAddress,
    shouldDisplayCustomFields: _shouldDisplayCustomFields,
    shouldDisplayCustomerName: _shouldDisplayCustomerName,
    shouldDisplayCustomerPhoneNumber: _shouldDisplayCustomerPhoneNumber,
    shouldDisplayNumberOfItems: _shouldDisplayNumberOfItems,
    shouldDisplayTotalOrderValue: _shouldDisplayTotalOrderValue,
  } = useAppSelector(SettingSelectors.selectOrderHeaderInterfaceSettings);

  return {
    shouldDisplayCustomerAddress:
      (_shouldDisplayCustomerAddress || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.customer_address,

    shouldDisplayCustomFields:
      (_shouldDisplayCustomFields || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.kds_custom_fields,

    shouldDisplayCustomerName:
      (_shouldDisplayCustomerName || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.customer_name,

    shouldDisplayCustomerPhoneNumber:
      (_shouldDisplayCustomerPhoneNumber || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.customer_phone_number,

    shouldDisplayNumberOfItems:
      (_shouldDisplayNumberOfItems || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.number_of_items,

    shouldDisplayTotalOrderValue:
      (_shouldDisplayTotalOrderValue || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.total_order_value,
  };
};
